<template>
  <el-dialog 
    width="540px"
    :title="dialog.title" 
    :visible.sync="dialog.isShow"
    @open='open' >
    <el-form ref="form" :model="form" label-width="80px" size="medium">     
      <el-col :span="24">
        <el-form-item label="店铺" >
          <el-input v-model="storeName" readonly placeholder="选择店铺">         
            <el-button slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
          </el-input>   
        </el-form-item>
      </el-col>   
      <el-col :span="24">
        <el-form-item label="产品" >
          <el-input v-model="productName" readonly placeholder="选择产品">         
            <el-button slot="append" icon="el-icon-search" @click="selectProductHandle">产品</el-button>
            <!-- <el-button slot="append" icon="el-icon-search" @click="selectProductHandle">SKU</el-button> -->
          </el-input>   
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="数量">
          <el-input-number v-model="form.number"  :min="1" :max="10000" label="数量"></el-input-number>
        </el-form-item>
      </el-col>     

      <el-col :span="24">
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.shareDescription"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">保 存</el-button>
    </div>    
    <GetProduct v-bind:dialogProduct="dialogProduct" @UpdateProduct="UpdateProduct"></GetProduct>
    <GetChainStore v-bind:dialogStore="dialogStore" @UpdateStore="UpdateStore"></GetChainStore>
  </el-dialog> 
</template>

<script  type='text/ecmascript-6'>
import GetProduct from '@/components/GetProduct'
import GetChainStore from '@/components/GetChainStore'
export default {
  props:{
    dialog:{}
  },
  data (){
    return {
      form : {
        chainStoreId:0,
        productId:0,
        memo:'',
        number:0
      },
      productName:'',
      storeName:'',
      dialogProduct:{
        isShow:false
      },
      dialogStore:{
        isShow:false
      },
    }
  },  
  components:{    
    GetProduct,
    GetChainStore
  },
  computed:{
  },
  mounted(){
  },
  methods:{   
    open:function(){      
     
    },     
    selectStoreHandle:function(){
      this.dialogStore.isShow = true
    },
    selectProductHandle:function(){
      this.dialogProduct.isShow = true
    },
    UpdateProduct:function(id,name){
      this.form.productId = id 
      this.productName = name 
      this.dialogProduct.isShow = false
    },
    UpdateStore:function(id,name){
      debugger
      this.form.chainStoreId = id 
      this.storeName = name 
      this.dialogStore.isShow = false
    },
    Save(){
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/ProductStock/purchase',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.$message.success(resp.data.message);
          that.dialog.isShow = false
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    }
  },
  created(){
  
  },
}
</script>